import { DateTimeFormatOptions } from 'luxon'

import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import { IField, TIntegratedSystems } from '@/types/tasksApprovals'
import { formatDate } from '@/utils/date'

const DateType = ({ item, system }: { item: IField; system: TIntegratedSystems }) => {
    const formatDateOptions = {
        weekday: 'long',
        month: 'long',
        day: '2-digit',
        year: 'numeric',
    } as DateTimeFormatOptions
    return (
        <Box py="8px" px="24px">
            <Text fontSize={12} pb="4px">
                {item.name}
            </Text>
            <Text fontSize={14} fontWeight="bold">
                {typeof item.value === 'string' &&
                    formatDate(item.value, system === 'SAP_GRC_ACCESS_REQUEST' ? formatDateOptions : undefined)}
            </Text>
        </Box>
    )
}

export default DateType
